import { Anima } from "./components/Anima";
import { Countdown } from "./components/Countdown";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { Home } from "./components/Home";
import { Space } from "./components/Space";
import { Team } from "./components/Team";
import { Ticket } from "./components/Ticket";
import { Welcome } from "./components/Welcome";
import { GlobalStyle } from "./styles/global";


export function App() {
  return (
    <>
      <Header />
      <Home />
      <Countdown />
      <Welcome />
      <Anima/>
      <Space />
      <Ticket />
      <Team/>
      <Footer/>
      <GlobalStyle/>
    </>
  );
}
